<template>
  <div class="company-wrap">
    <div class="company-top flex flex-row-between flex-items-start">
      <img src="@/static/images/company/1.png" alt="" srcset="" />
      <div class="company-top-center">
        <div class="flex">
          <p class="company-name">{{ information.name }}</p>
          <p class="company-tag">存续</p>
        </div>
        <div class="flex">
          <div class="flex">
            <img src="@/static/images/company/2.png" alt="" />
            <p>统一社会信用代码：{{ isCompany ? number : '---' }}</p>
          </div>
          <div class="flex">
            <img src="@/static/images/company/3.png" alt="" />
            <p>地址：{{ information.address ? information.address : '---' }}</p>
          </div>
        </div>
      </div>
      <div class="company-down" @click="downloadHandler">信用报告下载</div>
    </div>
    <div class="wrap-border">
      <ul class="flex company-link">
        <li
          class=""
          v-for="item in tabList"
          :key="item.id"
          :class="{ active: item.name === tabId }"
          @click="tabChange(item)"
        >
          {{ item.name }}
          <span v-if="!isUndefined(item.number)">{{ item.number }}</span>
        </li>
      </ul>
      <div class="company-content" v-if="tabId === '信息概览'">
        <empty v-if="!information" />
        <div class="flex flex-wrap flex-items-start flex-row-between" v-else>
          <div class="" @click="submitObjection" v-if="check">提起异议</div>
          <dl class="">
            <dt>统一社会信用代码：</dt>
            <dd>
              <span>{{ number }}</span>
            </dd>
          </dl>
          <dl class="">
            <dt>法人信息：</dt>
            <dd style="width: 58%">
              <span>{{
                information.realname ? information.realname : '---'
              }}</span>
            </dd>
          </dl>
          <dl class="">
            <dt>注册号：</dt>
            <dd>
              <span>{{
                information.regnumber ? information.regnumber : '---'
              }}</span>
            </dd>
          </dl>
          <dl class="">
            <dt>注册资本：</dt>
            <dd>
              <span>{{
                information.regcapital ? information.regcapital : '---'
              }}</span>
            </dd>
          </dl>
          <dl class="">
            <dt>注销时间：</dt>
            <dd>
              <span>{{
                information.canceltime ? information.canceltime : '---'
              }}</span>
            </dd>
          </dl>
          <dl class="">
            <dt>组织机构代码：</dt>
            <dd>
              <span>{{
                information.organizationcode
                  ? information.organizationcode
                  : '---'
              }}</span>
            </dd>
          </dl>
          <dl class="">
            <dt>公司类型：</dt>
            <dd>
              <span>{{ information.type ? information.type : '---' }}</span>
            </dd>
          </dl>
          <dl class="">
            <dt>成立日期：</dt>
            <dd>
              <span>{{
                information.settime ? information.settime : '---'
              }}</span>
            </dd>
          </dl>
          <dl class="">
            <dt>登记机关：</dt>
            <dd>
              <span>{{
                information.register ? information.register : '---'
              }}</span>
            </dd>
          </dl>
          <dl class="">
            <dt>经营范围：</dt>
            <dd>
              <span>{{
                information.managerange ? information.managerange : '---'
              }}</span>
            </dd>
          </dl>
        </div>
      </div>
      <div class="company-content" v-if="tabId === '行政许可'">
        <empty v-if="!list.length" />
        <el-card class="card" v-for="(item, index) in list" :key="index" v-else>
          <el-descriptions :column="1" border>
            <template slot="extra">
              <p>
                第<span>{{ index + 1 }}</span
                >条
              </p>
            </template>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 数据更新时间 </template>
              {{ item.clsj || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 法定代表人 </template>
              {{ item.xkFr || '---' }}
            </el-descriptions-item>

            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 当前状态 </template>
              {{ (item.enabledmark == 1 ? '有效' : '无效') || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 证件类型 </template>
              {{ item.sfzjmc || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 证件号码 </template>
              {{ item.sfzjhm || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 备注 </template>
              {{ item.bz || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 行政许可决定文书号 </template>
              {{ item.xkWsh || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 行政许可决定文书名称 </template>
              {{ item.xkXkws || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 许可证书名称 </template>
              {{ item.xkXkzs || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 许可类别 </template>
              {{ item.xkXklb || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 许可编号 </template>
              {{ item.xkXkbh || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 许可决定日期 </template>
              {{ item.xkJdrq || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 有效期自 </template>
              {{ item.xkYxqz || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 有效期至 </template>
              {{ item.xkJzq || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 许可内容 </template>
              {{ item.xkNr || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 许可机关 </template>
              {{ item.xkXkjg || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 许可机关统一社会信用代码 </template>
              {{ item.xkXkjgdm || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 数据来源单位 </template>
              {{ item.xkLydw || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 数据来源单位统一社会信用代码 </template>
              {{ item.xkLydwdm || '---' }}
            </el-descriptions-item>
          </el-descriptions>
<!--          <p class="company-desc">-->
<!--            说明：此详情页为2018年11月30日最新的模板内容-->
<!--          </p>-->
        </el-card>
      </div>
      <div class="company-content" v-if="tabId === '行政处罚'">
        <empty v-if="!list.length" />
        <ul class="flex flex-column" v-else>
          <li v-for="(item, index) in list" :key="index">
            <div class="flex flex-row-between company-list">
              <span :style="{ color: item.show ? 'rgb(247, 139, 13)' : '' }">{{
                item.cwsh
              }}</span>
              <span
                :title="item.csy"
                :style="{ color: item.show ? 'rgb(247, 139, 13)' : '' }"
                >{{ item.csy || '---' }}</span
              >
              <span :style="{ color: item.show ? 'rgb(247, 139, 13)' : '' }">{{
                item.cjdrq
              }}</span>
              <span
                class="show-button"
                :style="{ color: item.show ? 'rgb(247, 139, 13)' : '#d01c0b' }"
                @click="showHandler(item)"
                >{{ item.show ? '收起' : '查看详情' }}</span
              >
            </div>
            <div class="flex flex-wrap flex-items-start" v-if="item.show">
              <div
                class="abnormal-button"
                @click="submitObjection(item)"
                v-if="check"
              >
                提起异议
              </div>
              <div
                class="abnormal-button"
                @click="submitObjection(item, 2)"
                v-if="check"
              >
                信用修复
              </div>
              <p class="">
                <label> 行政处罚决定文书号： </label
                ><span :title="item.cwsh" style="width: 60%"
                  ><span>{{ item.cwsh || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 违法事实： </label
                ><span :title="item.csy"
                  ><span>{{ item.csy || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 数据更新时间： </label
                ><span :title="item.clsj" style="width: 70%"
                  ><span>{{ item.clsj || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 行政相对人名称： </label
                ><span :title="item.qymc" style="width: 60%"
                  ><span>{{ item.qymc || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 行政相对人类别： </label
                ><span :title="item.cxdrLb"
                  ><span>{{ item.cxdrLb || '---' }}</span></span
                >
              </p>
              <p class="">
                <label>统一社会信用代码： </label
                ><span :title="item.qyzch"
                  ><span>{{ item.qyzch || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 工商注册号： </label
                ><span :title="item.cxdrGszc"
                  ><span>{{ item.cxdrGszc || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 组织机构代码： </label
                ><span :title="item.zzjgdm"
                  ><span>{{ item.zzjgdm || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 税务登记号： </label
                ><span :title="item.cxdrSwdj"
                  ><span>{{ item.cxdrSwdj || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 事业单位证书号： </label
                ><span :title="item.cxdrSydw"
                  ><span>{{ item.cxdrSydw || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 社会组织登记证号： </label
                ><span :title="item.cxdrShzz"
                  ><span>{{ item.cxdrShzz || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 法定代表人： </label
                ><span :title="item.cfr" style="width: 70%"
                  ><span>{{ item.cfr || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 法定代表人证件类型： </label
                ><span :title="item.cfrZjlx" style="width: 50%"
                  ><span>{{ item.cfrZjlx || '---' }}</span></span
                >
              </p>

              <p class="">
                <label> 违法行为类型： </label
                ><span :title="item.cwfxw" style="width: 70%"
                  ><span>{{ item.cwfxw || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 证件类型： </label
                ><span :title="item.sfzjmc" style="width: 70%"
                  ><span>{{ item.sfzjmc || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 证件号码： </label
                ><span :title="item.sfzjhm" style="width: 70%"
                  ><span>{{ item.sfzjhm || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 备注： </label
                ><span :title="item.bz" style="width: 70%"
                  ><span>{{ item.bz || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 处罚有效期： </label
                ><span :title="item.cyxq" style="width: 70%"
                  ><span>{{ item.cyxq || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 公示截止期： </label
                ><span :title="item.cgsjzq" style="width: 70%"
                  ><span>{{ item.cgsjzq || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 权利事项名称： </label
                ><span :title="item.csxmc" style="width: 70%"
                  ><span>{{ item.csxmc || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 权利事项编码： </label
                ><span :title="item.csxdm" style="width: 70%"
                  ><span>{{ item.csxdm || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 处罚程序类型： </label
                ><span :title="item.ccflb" style="width: 70%"
                  ><span>{{ item.ccflb || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 当前状态： </label
                ><span :title="item.czt" style="width: 70%"
                  ><span>{{ item.czt || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 处罚内容： </label
                ><span :title="item.cnr" style="width: 70%"
                  ><span>{{ item.cnr || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 处罚类别： </label
                ><span :title="item.ccflb" style="width: 70%"
                  ><span>{{ item.ccflb || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 处罚依据： </label
                ><span :title="item.cyj" style="width: 70%"
                  ><span>{{ item.cyj || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 暂扣或吊销证照名称及编号： </label
                ><span :title="item.cnrZkdx" style="width: 50%"
                  ><span>{{ item.cnrZkdx || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 处罚决定日期： </label
                ><span :title="item.cjdrq" style="width: 70%"
                  ><span>{{ item.cjdrq || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 罚款金额（万元）： </label
                ><span :title="item.cnrFk + '万元'" style="width: 60%"
                  ><span>{{ item.cnrFk || '---' }}</span></span
                >
              </p>
              <p class="" style="width: 60%">
                <label> 没收违法所得、没收非法财物的金额（万元）： </label
                ><span :title="item.cnrWfff + '万元'" style="width: 50%"
                  ><span>{{ item.cnrWfff || '---' }}</span></span
                >
              </p>
              <p class="">
                <label> 处罚机关： </label
                ><span :title="item.ccfjg" style="width: 70%"
                  ><span>{{ item.ccfjg || '---' }}</span></span
                >
              </p>
              <p class="" style="width: 60%">
                <label>处罚机关统一社会信用代码： </label
                ><span :title="item.ccfjgdm" style="width: 70%"
                  ><span>{{ item.ccfjgdm || '---' }}</span></span
                >
              </p>
              <p class="">
                <label>数据来源单位： </label
                ><span title="item.csjly" style="width: 65%"
                  ><span>{{ item.csjly }}</span></span
                >
              </p>
              <p class="" style="width: 60%">
                <label> 数据来源单位统一社会信用代码： </label
                ><span :title="item.csjlydm" style="width: 60%"
                  ><span>{{ item.csjlydm }}</span></span
                >
              </p>
<!--              <p class="company-desc">-->
<!--                说明：此详情页为2018年11月30日最新的模板内容-->
<!--              </p>-->
            </div>
          </li>
        </ul>
      </div>
      <div
        class="company-content"
        v-if="['失信黑名单', '守信红名单'].includes(tabId)"
      >
        <empty v-if="!list.length" />
        <ul class="flex flex-column" v-else>
          <li v-for="(item, index) in list" :key="index">
            <div class="flex flex-row-between company-list">
              <span :style="{ color: item.show ? 'rgb(247, 139, 13)' : '' }">{{
                item.matterName
              }}</span>
              <span :style="{ color: item.show ? 'rgb(247, 139, 13)' : '' }">{{
                item.source
              }}</span>
<!--              <span :style="{ color: item.show ? 'rgb(247, 139, 13)' : '' }">{{-->
<!--                item.jointime-->
<!--              }}</span>-->
              <span
                class="show-button"
                :style="{ color: item.show ? 'rgb(247, 139, 13)' : '#d01c0b' }"
                @click="showHandler(item)"
                >{{ item.show ? '收起' : '查看详情' }}</span
              >
            </div>
            <div
              class="flex flex-wrap flex-items-start flex-row-between red-list"
              v-if="item.show"
            >
              <div
                class="abnormal-button"
                @click="submitObjection(item)"
                v-if="check"
              >
                提起异议
              </div>
              <div
                class="abnormal-button"
                @click="submitObjection(item, 4)"
                v-if="check && tabId == '失信黑名单'"
              >
                信用修复
              </div>
              <dl>
                <dt class="">
                  <span
                    >{{
                      tabId == '守信红名单' ? '红' : '黑'
                    }}名单事项名称：</span
                  >
                </dt>
                <dd class="">
                  <span class="" :title="item.matterName">{{
                    item.matterName || '---'
                  }}</span>
                </dd>
              </dl>
              <dl>
                <dt class=""><span>列入名单来源：</span></dt>
                <dd class="" style="width: 60%">
                  <span>{{ item.source || '---' }}</span>
                </dd>
              </dl>
              <dl>
                <dt class=""><span>列入名单事由：</span></dt>
                <dd class="">
                  <span class="">{{ item.matter || '---' }}</span>
                </dd>
              </dl>
              <dl>
                <dt class=""><span>备注：</span></dt>
                <dd class="" style="width: 68%">
                  <span>{{ item.description || '---' }}</span>
                </dd>
              </dl>
              <dl>
                <dt class=""><span>列入名单依据：</span></dt>
                <dd class="">
                  <span>{{ item.basis || '---' }}</span>
                </dd>
              </dl>
              <dl>
                <dt class=""><span>企业代码：</span></dt>
                <dd class="">
                  <span>{{ item.number || '---' }}</span>
                </dd>
              </dl>
<!--              <dl>-->
<!--                <dt class=""><span>列入名单日期：</span></dt>-->
<!--                <dd class="">-->
<!--                  <span>{{ item.jointime || '-&#45;&#45;' }}</span>-->
<!--                </dd>-->
<!--              </dl>-->
<!--              <dl>-->
<!--                <dt class=""><span></span></dt>-->
<!--                <dd class=""><span></span></dd>-->
<!--              </dl>-->
<!--              <dl>-->
<!--                <dt class=""><span>有效期：</span></dt>-->
<!--                <dd class="">-->
<!--                  <span>{{ item.validtime || '-&#45;&#45;' }}</span>-->
<!--                </dd>-->
<!--              </dl>-->
              <dl>
                <dt class=""><span></span></dt>
                <dd class=""></dd>
              </dl>
            </div>
          </li>
        </ul>
      </div>
      <!-- <div class="company-content" v-if="tabId === '失信黑名单'">
				<empty v-if="!list.length" />
				<ul class="flex flex-column" v-else>
					<li v-for="(item, index) in list" :key="index">
						<div class="flex flex-row-between company-list">
							<span :style="{color: item.show?'rgb(247, 139, 13)':''}">{{item.DECORG_CN||'---'}}</span>
							<span :style="{color: item.show?'rgb(247, 139, 13)':''}">{{item.SPECAUSE_CN||'---'}}</span>
							<span :style="{color: item.show?'rgb(247, 139, 13)':''}">{{toDateString(item.ABNTIME, 'yyyy-MM-dd')||'---'}}</span>
							<span class="show-button" :style="{color: item.show?'rgb(247, 139, 13)':'#d01c0b'}" @click="showHandler(item)">{{item.show?'收起':'查看详情'}}</span>
						</div>
						<div class="flex flex-wrap flex-items-start flex-row-between abnormal-list" v-if="item.show">
							<div class="abnormal-button" @click="submitObjection(item)">提起异议</div>
							<dl>
								<dt><span>作出决定机关：</span></dt>
								<dd><span>{{item.DECORG_CN||'---'}}</span></dd>
							</dl>
							<dl>
								<dt><span>被列入异常名录日期：</span></dt>
								<dd><span>{{toDateString(item.ABNTIME, 'yyyy-MM-dd')||'---'}}</span></dd>
							</dl>
							<dl>
								<dt><span>列入异常名录原因：</span></dt>
								<dd><span>{{item.SPECAUSE_CN||'---'}}</span></dd>
							</dl>
							<dl>
								<dt><span>被移出异常名录日期：</span></dt>
								<dd><span>{{toDateString(item.REMDATE, 'yyyy-MM-dd')||'---'}}</span></dd>
							</dl>
							<dl>
								<dt><span>移出异常名录原因：</span></dt>
								<dd><span>{{item.REMEXCPRES_CN||'---'}}</span></dd>
							</dl>
						</div>
					</li>
				</ul>
			</div> -->
      <div class="company-content" v-if="tabId === '企业经营异常名录'">
        <empty v-if="!list.length" />
        <ul class="flex flex-column" v-else>
          <li v-for="(item, index) in list" :key="index">
            <div class="flex flex-row-between company-list">
              <span :style="{ color: item.show ? 'rgb(247, 139, 13)' : '' }">{{
                item.decidename || '---'
              }}</span>
              <span :style="{ color: item.show ? 'rgb(247, 139, 13)' : '' }">{{
                item.description || '---'
              }}</span>
              <span :style="{ color: item.show ? 'rgb(247, 139, 13)' : '' }">{{
                item.abnormaltime || '---'
              }}</span>
              <span
                class="show-button"
                :style="{ color: item.show ? 'rgb(247, 139, 13)' : '#d01c0b' }"
                @click="showHandler(item)"
                >{{ item.show ? '收起' : '查看详情' }}</span
              >
            </div>
            <div
              class="
                flex flex-wrap flex-items-start flex-row-between
                abnormal-list
              "
              v-if="item.show"
            >
              <div
                class="abnormal-button"
                @click="submitObjection(item)"
                v-if="check"
              >
                提起异议
              </div>
              <div
                class="abnormal-button repair-button"
                @click="submitObjection(item, 5)"
                v-if="check"
              >
                信用修复
              </div>
              <dl>
                <dt><span>作出决定机关：</span></dt>
                <dd>
                  <span>{{ item.decidename || '---' }}</span>
                </dd>
              </dl>
              <dl>
                <dt><span>被列入异常名录日期：</span></dt>
                <dd>
                  <span>{{
                    toDateString(item.abnormaltime, 'yyyy-MM-dd') || '---'
                  }}</span>
                </dd>
              </dl>
              <dl>
                <dt><span>列入异常名录原因：</span></dt>
                <dd>
                  <span>{{ item.description || '---' }}</span>
                </dd>
              </dl>
              <dl>
                <dt><span>被移出异常名录日期：</span></dt>
                <dd>
                  <span>{{
                    toDateString(item.REMDATE, 'yyyy-MM-dd') || '---'
                  }}</span>
                </dd>
              </dl>
              <dl>
                <dt><span>移出异常名录原因：</span></dt>
                <dd>
                  <span>{{ item.REMEXCPRES_CN || '---' }}</span>
                </dd>
              </dl>
            </div>
          </li>
        </ul>
      </div>

      <div class="company-content" v-if="tabId === '司法判决'">
        <empty v-if="!list.length" />
        <el-card v-for="(item, index) in list" :key="index" v-else>
          <el-descriptions :labelStyle="labelStyle" :column="1" border>
            <template slot="extra">
              <p>
                第<span>{{ index + 1 }}</span
                >条
              </p>
            </template>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 统一社会信用代码 </template>
              {{ item.number || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 案号 </template>
              {{ item.caseNo || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 案件类型 </template>
              {{ item.caseType || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 审判程序 </template>
              {{ item.trialProcedure || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 文书类型 </template>
              {{ item.documentType || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 案由 </template>
              {{ item.caseCause || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 裁判日期 </template>
              {{ item.caseTime || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 审理法院 </template>
              {{ item.caseUnit || '---' }}
            </el-descriptions-item>
          </el-descriptions>
          <p class="company-desc">
            <span style="color: red">风险提示：</span>
            <span
              >本网站仅基于已掌握的信息提供查询服务，查询结果不代表本网站对被查询对象信用状况的评价，仅供参考，请注意识别和防范信用风险。</span
            >
          </p>
        </el-card>
      </div>

<!--      <div class="page-wrap" v-if="tabId !== '信息概览' && total > 0">-->
<!--        <el-pagination-->
<!--          @current-change="handleCurrentChange"-->
<!--          :current-page.sync="currentPage"-->
<!--          :page-size="pageSize"-->
<!--          layout="prev, pager, next, jumper"-->
<!--          :total="total"-->
<!--        >-->
<!--        </el-pagination>-->
<!--      </div>-->
      <div class="company-content" v-if="tabId === '信用承诺'">
        <empty v-if="!list.length" />
        <el-card class="card" v-for="(item, index) in list" :key="index" v-else>
          <el-descriptions :column="1" border>
            <template slot="extra">
              <p>
                第<span>{{ index + 1 }}</span
                >条
              </p>
            </template>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 承诺编码 </template>
              {{ item.cnbm || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 承诺类型 </template>
              {{ item.cnlx || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 承诺事由 </template>
              {{ item.cnsy || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 承诺内容 </template>
              {{ item.cnnr || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 承诺作出日期 </template>
              {{ item.cnzcrq || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 承诺履行状态 </template>
              {{ item.cnlxzt || '---' }}
            </el-descriptions-item>

            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
              >>
              <template slot="label"> 承诺受理单位 </template>
              {{ item.cnsldw || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelClassName="labelClassName"
              :contentClassName="contentClassName"
            >
              <template slot="label"> 承诺受理单位统一社会信用代码 </template>
              {{ item.cnsldwtyshxydm || '---' }}
            </el-descriptions-item>
          </el-descriptions>
        </el-card>
      </div>

      <div class="company-content" v-if="tabId === '信用评价'">
        <empty v-if="!list.length" />
        <el-card class="card" v-for="(item, index) in list" :key="index" v-else>
          <el-descriptions :column="1" border>
            <template slot="extra">
              <p>
                第<span>{{ index + 1 }}</span
              >条
              </p>
            </template>
            <el-descriptions-item
                :labelClassName="labelClassName"
                :contentClassName="contentClassName"
            >
              <template slot="label"> 企业类型 </template>
              {{ item.type || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
                :labelClassName="labelClassName"
                :contentClassName="contentClassName"
            >
              <template slot="label"> 企业名称 </template>
              {{ item.name || '---' }}
            </el-descriptions-item>

            <el-descriptions-item
                :labelClassName="labelClassName"
                :contentClassName="contentClassName"
            >
              <template slot="label"> 法人代表 </template>
              {{ item.realname || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
                :labelClassName="labelClassName"
                :contentClassName="contentClassName"
            >
              <template slot="label"> 统一社会信用代码 </template>
              {{ item.number || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
                :labelClassName="labelClassName"
                :contentClassName="contentClassName"
            >
              <template slot="label"> 评价等级 </template>
              {{ item.scoreLevel || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
                :labelClassName="labelClassName"
                :contentClassName="contentClassName"
            >
              <template slot="label"> 注册地址 </template>
              {{ item.address || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
                :labelClassName="labelClassName"
                :contentClassName="contentClassName"
            >
              <template slot="label"> 成立时间 </template>
              {{ item.settime || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
                :labelClassName="labelClassName"
                :contentClassName="contentClassName"
            >
              <template slot="label"> 注册号 </template>
              {{ item.regnumber || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
                :labelClassName="labelClassName"
                :contentClassName="contentClassName"
            >
              <template slot="label"> 经营范围 </template>
              {{ item.managerange || '---' }}
            </el-descriptions-item>
            <el-descriptions-item
                :labelClassName="labelClassName"
                :contentClassName="contentClassName"
            >
              <template slot="label"> 登记机关 </template>
              {{ item.register || '---' }}
            </el-descriptions-item>
          </el-descriptions>
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 许可编号 </template>-->
<!--              {{ item.xkXkbh || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 许可决定日期 </template>-->
<!--              {{ item.xkJdrq || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 有效期自 </template>-->
<!--              {{ item.xkYxqz || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 有效期至 </template>-->
<!--              {{ item.xkJzq || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 许可内容 </template>-->
<!--              {{ item.xkNr || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 许可机关 </template>-->
<!--              {{ item.xkXkjg || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 许可机关统一社会信用代码 </template>-->
<!--              {{ item.xkXkjgdm || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 数据来源单位 </template>-->
<!--              {{ item.xkLydw || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 数据来源单位统一社会信用代码 </template>-->
<!--              {{ item.xkLydwdm || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->

<!--          <p class="company-desc">-->
<!--            说明：此详情页为2018年11月30日最新的模板内容-->
<!--          </p>-->
<!--        </el-card>-->
<!--        <el-card v-for="(item, index) in list" :key="index" v-else>-->
<!--          <el-descriptions :column="1" border>-->
<!--&lt;!&ndash;            <template slot="extra">&ndash;&gt;-->
<!--&lt;!&ndash;              <p>&ndash;&gt;-->
<!--&lt;!&ndash;                第<span>{{ index + 1 }}</span&ndash;&gt;-->
<!--&lt;!&ndash;              >条&ndash;&gt;-->
<!--&lt;!&ndash;              </p>&ndash;&gt;-->
<!--&lt;!&ndash;            </template>&ndash;&gt;-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 类型 </template>-->
<!--              {{ item.type || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 名称 </template>-->
<!--              {{ item.name || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 人 </template>-->
<!--              {{ item.realname || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 信用代码 </template>-->
<!--              {{ item.number || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 评分级别 </template>-->
<!--              {{ item.scoreLevel || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 地址 </template>-->
<!--              {{ item.address || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->

<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >>-->
<!--              <template slot="label"> 时间 </template>-->
<!--              {{ item.regnumber || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> 业务 </template>-->
<!--              {{ item.managerange || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--            <el-descriptions-item-->
<!--                :labelClassName="labelClassName"-->
<!--                :contentClassName="contentClassName"-->
<!--            >-->
<!--              <template slot="label"> register </template>-->
<!--              {{ item.register || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--          </el-descriptions>-->
<!--          <el-descriptions :column="1" border>-->
<!--            <template slot="extra">-->
<!--              <p>-->
<!--                第<span>{{ index + 1 }}</span-->
<!--                >条-->
<!--              </p>-->
<!--            </template>-->
<!--            <el-descriptions-item>-->
<!--              <template slot="label"> 数据更新时间 </template>-->
<!--              {{ item.clsj || '-&#45;&#45;' }}-->
<!--            </el-descriptions-item>-->
<!--          </el-descriptions>-->
<!--          <p class="company-desc">-->
<!--            说明：此详情页为2018年11月30日最新的模板内容3-->
<!--          </p>-->
        </el-card>
      </div>
    </div>

    <dialog-appeals ref="dialogAppealsRef" />
  </div>
</template>

<script>
import isUndefined from 'xe-utils/isUndefined'
import toDateString from 'xe-utils/toDateString'

import dialogAppeals from './dialog-appeals.vue'

// const labelStyle = {
//   width: '30%',
// }

const tabList = [
  {
    id: 1,
    name: '信息概览',
  },
  {
    id: 2,
    name: '行政许可',
    key: 'permitCount',
    number: 0,
  },
  {
    id: 3,
    name: '行政处罚',
    key: 'punishCount',
    number: 0,
  },
  {
    id: 4,
    name: '守信红名单',
    key: 'redListCount',
    number: 0,
  },
  {
    id: 5,
    name: '失信黑名单',
    key: 'blackListCount1',
    number: 0,
  },
  {
    id: 6,
    name: '企业经营异常名录',
    key: 'abnormalListCount',
    number: 0,
  },
  {
    id: 7,
    name: '信用承诺',
    key: 'promiseCount',
    number: 0,
  },
  {
    id: 8,
    name: '信用评价',
    key: 'creditRatingCount',
    number: 10,
  },
  {
    id: 9,
    name: '司法判决',
    key: 'courtDecisionCount',
    number: 0,
  },
]

import {
  enterprise,
  count,
  permit,
  punish,
  companyRedList,
  companyBlackList,
  abnormal,
  checkEnterpriseClaim,
  downloadCreditReport,
  getPdfFile,
  courtDecisionList,
  promiseList,
  creditLevelList,
} from '@/api'

import empty from '@/components/empty'
import { Message } from 'element-ui'
import { createNodeElement_a } from '@/utils/createNode.js'
export default {
  components: {
    empty,
    dialogAppeals,
  },
  data() {
    return {
      contentClassName: { background: 'rgba(255, 255, 255, 0.3)' },
      labelClassName: { background: 'rgba(255, 255, 255, 0.3)' },
      labelStyle: {
        width: '30%',
        background: 'rgba(255, 255, 255, 0.3)',
      },
      number: undefined, //社会信用代码
      tabList: [],
      tabId: '信息概览',

      information: {}, //信息概览， 标题等

      pageSize: 10,
      total: 0,
      currentPage: 1,
      list: [],
      check: undefined,
    }
  },
  created() {},
  mounted() {
    const {
      query: { tab, number, name },
    } = this.$route
    if (number) {
      this.number = number
      if (name) {
        this.$set(this.information, 'name', name)
      }
      this.getEnterpriseInformation()
    }
    this.$set(this, 'tabId', tab ? tab : '信息概览')

    count({ number }).then((res) => {
      this.$set(
        this,
        'tabList',
        tabList.map((item) =>
          Object.assign({}, item, {
            number: res[item.key],
          })
        )
      )
    })
    if (!!this.$store.state.token) {
      this.checkStatus()
    }
  },
  methods: {
    isUndefined,
    toDateString,
    // 基本信息
    getEnterpriseInformation() {
      enterprise({ number: this.number }).then((res) => {
        this.$set(this, 'information', res || {})
      })
    },
    // 检查是否能提起异议
    checkStatus(data) {
      checkEnterpriseClaim({
        number: this.number,
      }).then((res) => {
        this.$set(this, 'check', res)
      })
    },
    setResponse(response) {
      const { records, size, current, total } = response
      this.$set(this, 'list', records || [])
      this.$set(this, 'total', total)
      this.$set(this, 'pageSize', size)
    },
    // 行政许可
    getEnterpriseLicense(page = 1) {
      permit({ number: this.number, current: page }).then((res) => {
        this.setResponse(res)
      })
    },
    // 行政处罚
    getEnterprisePunish(page = 1) {
      punish({ number: this.number, current: page }).then((res) => {
        this.setResponse(res)
      })
    },

    // 信用承诺
    getPromiseList(page = 1) {
      promiseList({
        number: this.number,
        page: page,
      }).then((res) => {
        this.setResponse(res)
      })
    },

    getRedList(page = 1) {
      companyRedList({ number: this.number, current: page }).then((res) => {
        this.setResponse(res)
        console.log("1111")
        console.log(res)

      })
    },
    // 司法判决
    getcourtDecisionList(page = 1) {
      courtDecisionList({
        keyword: this.number,
        type: '法人及非法人组织',
        page: 1,
      }).then((res) => {
        // console.log(res)
        this.setResponse(res)
      })
    },

    // 信用评价
    getcreditLevel(page = 1) {
      creditLevelList({ number: this.number, current: page }).then((res) => {
        this.setResponse(res)
        console.log("2222")
        console.log(res)
      })
    },

    getBlackList(page = 1) {
      companyBlackList({ number: this.number, current: page }).then((res) => {
        this.setResponse(res)
      })
    },
    // 企业经营异常名录
    getAbnormal(page = 1) {
      abnormal({ number: this.number, current: page }).then((res) => {
        this.setResponse(res)
      })
    },
    tabChange(row) {
      const { name } = row
      if (name) {
        this.$set(this, 'tabId', name)
        this.list = []
        this.getData(1)
      }
    },
    getData(page = 1) {
      this.resetHandler()
      switch (this.tabId) {
        case '信息概览':
          this.getEnterpriseInformation()
          break
        case '行政许可':
          this.getEnterpriseLicense(page)
          break
        case '行政处罚':
          this.getEnterprisePunish(page)
          break
        case '守信红名单':
          this.getRedList(page)
          break
        case '失信黑名单':
          this.getBlackList(page)
          break
        case '企业经营异常名录':
          this.getAbnormal(page)
          break
        case '司法判决':
          this.getcourtDecisionList(page)
          break
        case '信用承诺':
          this.getPromiseList(page)
          break
        case '信用评价':
          this.getcreditLevel(page)
          break
        default:
          this.getEnterpriseInformation()
          break
      }
    },
    resetHandler() {
      this.$set(this, 'list', [])
      this.$set(this, 'total', 0)
      this.$set(this, 'pageSize', 15)
    },
    // 信用报告下载
    downloadHandler() {
      getPdfFile({
        number: this.information.number,
      }).then((response) => {
        if (response.code != 500) {
          createNodeElement_a(response, 'application/pdf', '企业信用报告')
        } else {
          Message({
            message: response.message,
            type: 'warning',
            duration: 3000,
          })
        }
      })
    },
    // 异议申诉弹窗+信用修复
    submitObjection(row, type) {
      if (!this.$store.state.token) {
        this.$router.replace('/login')
      }
      if (!!type) {
        this.$router.push({
          path: `/user/repair`,
          query: {
            number: this.number,
            appealtype: type,
            name: this.information.name,
            dataId: row.id,
          },
        })
      } else {
        checkEnterpriseClaim({
          number: this.number,
        }).then((res) => {
          this.$set(this, 'check', res)
          if (res) {
            this.$refs['dialogAppealsRef'].show(
              Object.assign({}, this.information || {}, {
                tab: this.tabId === '信息概览' ? {} : row,
                tabId: this.tabId,
                name: this.information.name,
              })
            )
          }
        })
      }
    },
    handleCurrentChange(e) {
      this.getData(e)
    },

    showHandler(row) {
      const { show = undefined } = row
      this.$set(row, 'show', !show)
    },
  },
  computed: {
    isCompany({ $route }) {
      const {
        query: { name },
      } = $route
      return !name
    },
  },
  watch: {
    $route: {
      handler(v) {
        const {
          query: { tab, number },
        } = v
        this.number = number
        this.tabId = tab
        this.getData()
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.my-label {
  background: rgba(255, 255, 255, 0.3);
}

.my-content {
  background: rgba(255, 255, 255, 0.3);
}
.card {
  margin-top: 2%;
  background: url(../static/images/watermark.png) left top repeat;
  border: 1px solid #dddddd;
  border-bottom: 0;
  border-right: 0;
  //   width: 100%;
}

.company-wrap {
  width: 1280px;
  margin: 0 auto;
  padding: 46px 0 72px;
  & > .company-top {
    & > .company-top-center {
      padding: 0 10px;
      flex-grow: 2;
      text-align: left;
      & > .flex {
        & + .flex {
          margin-left: 10px;
          margin-top: 15px;
          font-size: 12px;
          color: #646567;
          height: 12px;
          line-height: 12px;
          & > .flex {
            &:first-of-type {
              margin-right: 40px;
            }
            & > img {
              height: 12px;
              margin-right: 10px;
            }
          }
        }
        & > .company-name {
          height: 28px;
          line-height: 28px;
          font-size: 20px;
          color: #212121;
          font-weight: 400;
        }
        & > .company-tag {
          height: 28px;
          line-height: 28px;
          padding: 0 16px;
          vertical-align: top;
          border-radius: 14px;
          background: #f9e7d1;
          color: #ffa353;
          font-size: 14px;
          margin-left: 12px;
          box-sizing: border-box;
        }
      }
    }
    & > .company-down {
      height: 34px;
      line-height: 34px;
      width: 124px;
      text-align: center;
      border-radius: 4px;
      background-color: $red;
      font-size: 14px;
      vertical-align: top;
      color: #fff;
      cursor: pointer;
      align-self: flex-end;
    }
  }
  & > .wrap-border {
    margin: 20px 0 0;
    & > .company-link {
      & > li {
        flex-basis: 20%;
        text-align: center;
        font-size: 12px;
        color: #212121;
        display: inline-block;
        border-width: 0 1px 1px 0;
        border-style: solid;
        border-color: #e0e7ed;
        height: 50px;
        line-height: 50px;
        box-sizing: border-box;
        cursor: pointer;
        &.active {
          border-bottom: 4px solid $red;
          color: $red;
        }
        & > span {
          display: inline-block;
          height: 18px;
          line-height: 18px;
          padding: 0 12px;
          background: $red;
          color: #fff;
          border-radius: 9px;
          margin-left: 6px;
        }
      }
    }
    & > .company-content {
      & > div.flex {
        width: 90%;
        margin: 0 auto;
        padding: 40px 0;
      }
      & > ul.flex {
        width: 100%;
      }
      .flex {
        position: relative;
        & > div {
          position: absolute;
          right: 64px;
          top: 45px;
          width: 70px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          background: $red;
          color: #fff;
          cursor: pointer;
        }
        & > dl {
          flex-basis: 50%;
          line-height: 40px;
          display: flex;
          & > dt {
            flex-shrink: 0;
          }
          & > dd {
            text-align: left;
            span {
              line-height: 20px;
              display: inline-block;
            }
          }
        }
        & > li {
          width: 100%;
          margin-bottom: 10px;
          min-height: 48px;
          padding: 0 5%;
          & > .company-list {
            min-height: 48px;
            & > span {
              flex-basis: 30%;
              padding-right: 10px;
              padding-top: 5px;
              box-sizing: border-box;
              text-align: left;
              flex-shrink: 0;
              &:last-child(2) {
                flex-basis: 10%;
              }
            }
          }
          &:nth-child(even) {
            background-color: #f1f5f8;
          }
          .show-button {
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
          & > .red-list {
            & > dl {
              & > dd {
                span {
                  color: $red;
                }
              }
            }
          }
          & > .flex {
            & > p {
              display: flex;
              flex-basis: 30%;
              text-align: left;
              padding: 10px 10px 10px 0;
              flex-shrink: 0;
              & > span {
                color: #e25670;
                line-height: 20px;
              }
              & > label {
                flex-shrink: 0;
              }
              &.company-desc {
                display: block;
                line-height: 3;
                color: rgb(226, 86, 112);
                flex-basis: 100%;
              }
            }
          }
          & > .abnormal-list {
            & > dl {
              flex-basis: 100%;
              & > dd {
                & > span {
                  color: #e25670;
                }
              }
            }
          }
          .abnormal-button {
            top: 5px;
          }
          .repair-button {
            top: 5px;
            right: -10px;
          }
        }
      }
    }
    .page-wrap {
      text-align: right;
      padding-bottom: 20px;
    }
  }
}
</style>
